import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const reviews = [{
  name: 'Mariana L.',
  location: 'CABA',
  cat: 'Michi, 3 años',
  stars: 5,
  text: 'Boludo, no lo puedo creer. Michi me meaba el sillón TODOS los días. Yo ya estaba por regalarlo (al sillón, no al gato, jaja). Seguí el protocolo al pie de la letra y al tercer día dejó de hacerlo. TERCER DÍA. Llevo dos semanas y ni un accidente. Estoy re emocionada.'
}, {
  name: 'Facundo R.',
  location: 'Rosario',
  cat: 'Pancho, 5 años',
  stars: 5,
  text: 'Mi vieja me decía "ese gato está loco, llevalo al veterinario". Lo llevé, le hicieron de todo, y el veterinario me dijo que no tenía nada. Era conductual. Con la guía entendí que la bandeja estaba al lado del lavarropas y cada vez que centrifugaba, Pancho se estresaba mal. La moví y chau problema.'
}, {
  name: 'Camila S.',
  location: 'Mendoza',
  cat: 'Luna y Sol, 2 años',
  stars: 5,
  text: 'Tengo dos gatas y una sola bandeja. Grave error, según la guía. Puse la segunda bandeja donde me indicó el mapa N+1 y las dos empezaron a usarla como corresponde. Me quiero matar por no haberlo hecho antes. Gasté fortunas en arenas premium y el tema era la UBICACIÓN.'
}, {
  name: 'Tomás D.',
  location: 'La Plata',
  cat: 'Bigotes, 7 años',
  stars: 5,
  text: 'Bigotes es un gato grande, ya veterano. Empezó a marcar cuando nació mi hijo. Yo pensé que eran celos y no tenía solución. El protocolo me enseñó que era estrés territorial y me dio pasos concretos para reintroducir las zonas seguras. En 5 días volvió a la bandeja. Mi señora no lo podía creer.'
}, {
  name: 'Florencia M.',
  location: 'Córdoba',
  cat: 'Simba, 4 años',
  stars: 5,
  text: 'Yo limpiaba con lavandina. SÍ, LAVANDINA. No sabía que para el gato eso es como un cartel de neón que dice "meá acá". Cuando cambié el producto de limpieza con la receta del bono, Simba dejó de ir al rincón de la cocina. Literal fue mágico. Re vale la pena.'
}, {
  name: 'Gonzalo P.',
  location: 'Tucumán',
  cat: 'Negrita, 6 años',
  stars: 5,
  text: 'Mi novia me mandó el link y yo pensé "otro chamuyo más". Pero bueno, ya habíamos probado Feliway, arena de sílice, arena aglomerante, repelentes... nada funcionaba. Hice la auditoría express del bono 1 y descubrí que la bandeja estaba en un pasillo con corriente de aire. La moví al lavadero y santo remedio.'
}, {
  name: 'Agustina V.',
  location: 'Mar del Plata',
  cat: 'Cleo, 2 años',
  stars: 5,
  text: 'Cleo me hacía pis en la cama. EN MI CAMA. Yo dormía con un nylon abajo de la sábana, una vergüenza. Seguí el protocolo y lo que más me sirvió fue el kit de comunicación, porque mi roommate dejaba la puerta del cuarto abierta y Cleo entraba. Alineamos la casa y en 4 días se terminó el drama.'
}, {
  name: 'Martín K.',
  location: 'Bahía Blanca',
  cat: 'Tito y Mía, 3 y 1 año',
  stars: 5,
  text: 'Cuando adopté a Mía, Tito empezó a marcar todo. El sofá, las cortinas, hasta la mochila que dejo en el piso. Con el protocolo entendí el tema territorial entre los dos y armé las zonas como dice la guía. En una semana se calmó todo. Ahora duermen juntos en el mismo sillón. Una locura.'
}, {
  name: 'Lucía B.',
  location: 'Santa Fe',
  cat: 'Pelusa, 8 años',
  stars: 5,
  text: 'Pelusa tiene 8 años y nunca había tenido problemas. Cuando me mudé, empezó a hacer pis por todos lados. El veterinario me dijo "es el estrés de la mudanza, ya se le va a pasar". Pasaron 3 meses y nada. Con el protocolo resolví todo en menos de una semana. Ojalá el veterinario me hubiera dicho esto antes.'
}, {
  name: 'Diego A.',
  location: 'Neuquén',
  cat: 'Mostaza, 4 años',
  stars: 5,
  text: 'Soy re escéptico con estas cosas, pero mi hermana lo compró y le funcionó con su gata. Así que dije "bueno, dale". Mostaza meaba atrás del televisor y yo ni me daba cuenta hasta que el olor era insoportable. Hice la auditoría, cambié la bandeja de lugar, limpié bien la zona con la receta del bono y listo. No volvió más.'
}];
export function ReviewsSection() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const goTo = (index: number) => {
    setDirection(index > current ? 1 : -1);
    setCurrent(index);
  };
  const goNext = () => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % reviews.length);
  };
  const goPrev = () => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + reviews.length) % reviews.length);
  };
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0
    })
  };
  const review = reviews[current];
  return <section className="w-full bg-[#FAFAF7] py-8 md:py-20 px-4 md:px-6" data-id="element-339">
      <div className="max-w-3xl mx-auto" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 md:mb-10" data-id="element-341">
          <div className="inline-flex items-center gap-1.5 bg-[#2D8C5A]/10 text-[#2D8C5A] font-semibold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-342">
            Reseñas
          </div>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-343">
            Lo que dicen los que ya lo probaron
          </h2>
          <p className="text-lg text-[#1C1C1C]/70 max-w-2xl mx-auto" data-id="element-344">
            Historias reales de dueños de gatos en Argentina que dejaron de
            sufrir con el marcaje fuera de la bandeja.
          </p>
        </motion.div>

        {/* Carousel */}
        <div className="relative" data-id="element-345">
          {/* Arrow buttons */}
          <button onClick={goPrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-14 z-10 w-10 h-10 bg-white rounded-full shadow-md border border-[#1C1C1C]/10 flex items-center justify-center hover:bg-[#FAFAF7] transition-colors cursor-pointer" aria-label="Reseña anterior" data-id="element-346">
            <ChevronLeftIcon className="w-5 h-5 text-[#1C1C1C]/70" data-id="element-347" />
          </button>
          <button onClick={goNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-14 z-10 w-10 h-10 bg-white rounded-full shadow-md border border-[#1C1C1C]/10 flex items-center justify-center hover:bg-[#FAFAF7] transition-colors cursor-pointer" aria-label="Reseña siguiente" data-id="element-348">
            <ChevronRightIcon className="w-5 h-5 text-[#1C1C1C]/70" data-id="element-349" />
          </button>

          {/* Card container */}
          <div className="overflow-hidden rounded-xl mx-6 md:mx-0" data-id="element-350">
            <div className="relative min-h-[260px] md:min-h-[220px]" data-id="element-351">
              <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-352">
                <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
                x: {
                  type: 'spring',
                  stiffness: 300,
                  damping: 30
                },
                opacity: {
                  duration: 0.2
                }
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.12} onDragEnd={(_, info) => {
                if (info.offset.x < -60) goNext();else if (info.offset.x > 60) goPrev();
              }} className="bg-white rounded-xl p-6 md:p-8 border border-[#1C1C1C]/5 shadow-sm cursor-grab active:cursor-grabbing" data-id="element-353">
                  <div className="flex items-center gap-1 mb-3" data-id="element-354">
                    {Array.from({
                    length: review.stars
                  }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#F59E0B] fill-[#F59E0B]" data-id="element-355" />)}
                  </div>
                  <p className="text-[#1C1C1C] text-sm md:text-base leading-relaxed mb-5" data-id="element-356">
                    "{review.text}"
                  </p>
                  <div className="flex items-center justify-between" data-id="element-357">
                    <div data-id="element-358">
                      <p className="text-sm font-semibold text-[#1C1C1C]" data-id="element-359">
                        {review.name}
                      </p>
                      <p className="text-xs text-[#1C1C1C]/50" data-id="element-360">
                        {review.location} · 🐱 {review.cat}
                      </p>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-6" data-id="element-361">
          {reviews.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`transition-all duration-300 rounded-full cursor-pointer ${index === current ? 'w-6 h-2.5 bg-[#2D8C5A]' : 'w-2.5 h-2.5 bg-[#1C1C1C]/15 hover:bg-[#1C1C1C]/30'}`} aria-label={`Ir a reseña ${index + 1}`} data-id="element-362" />)}
        </div>

        {/* Counter */}
      </div>
    </section>;
}